import React, { useState, useRef, useEffect } from "react";
import TabList from "./tabList/TabList";
import Subtabs from "./subtabs/Subtabs";
import MenuButton from "../menuButton/MenuButton";
import Header from "../header/Header";
import "./Tabs.css";
import { Tab } from "../../types/navigation";

interface TabsProps {
  tabs: Tab[];
  activeTab: string | null;
  setActiveTab: (tabId: string | null) => void;
  clickedTab: string | null;
  setClickedTab: (tabId: string | null) => void;
  clickedSubTab: string | null;
  setClickedSubTab: (subTabId: string | null) => void;
  setShowBackground: (show: boolean) => void;
  isMobile: boolean;
  bgImgRef: React.RefObject<HTMLDivElement>;
  headerRef: React.RefObject<HTMLDivElement>;
  onLogoClick: () => void;
  resetActiveProduct: () => void;
}

function Tabs({
  tabs,
  activeTab,
  setActiveTab,
  clickedTab,
  setClickedTab,
  clickedSubTab,
  setClickedSubTab,
  setShowBackground,
  isMobile,
  bgImgRef,
  headerRef,
  onLogoClick,
  resetActiveProduct,
}: TabsProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const subtabsRef = useRef<HTMLDivElement>(null);
  const tabsRef = useRef<HTMLUListElement>(null);

  // Set first tab as active by default
  useEffect(() => {
    if (tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0].id);
    }
  }, [tabs]);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  const handleTabHover = (tabId: string) => {
    if (!isMobile) {
      setActiveTab(tabId);
    }
  };

  const toggleMenu = () => {
    // Scroll to top before opening menu
    window.scrollTo({ top: 0 });
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Clean up body style on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <>
      <MenuButton isOpen={isMenuOpen} onClick={toggleMenu} />
      <div className={`menu-overlay ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <div className="menu-content" onClick={(e) => e.stopPropagation()}>
          <div className="min-h-[69px]">
            <Header
              onLogoClick={() => {
                onLogoClick();
                toggleMenu();
              }}
              resetActiveProduct={resetActiveProduct}
              isMobileMenuOpen={isMenuOpen}
              toggleMobileMenu={toggleMenu}
              headerRef={headerRef}
            />
          </div>
          <TabList
            tabs={tabs}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            handleTabHover={handleTabHover}
            isMobile={isMobile}
            subtabsRef={subtabsRef}
            tabsRef={tabsRef}
            bgImgRef={bgImgRef}
            headerRef={headerRef}
          />
          <Subtabs
            ref={subtabsRef}
            activeTab={activeTab}
            isMobile={isMobile}
            onNavigate={closeMenu}
          />
        </div>
      </div>
    </>
  );
}

export default Tabs;
